import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { ElasticSearchResponse } from '../../@types/ElasticSearchResponse';
import type { LiveShopping } from '../../@types/LiveShopping';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import type { ApiResponse } from '../../Http';
import { buildGetRequest } from '../../Http/requestTemplates';
import useHttp from '../../Http/useHttp';
import { FEATURED_LIVESHOPPING } from './QueryKeys';

const useFeaturedLiveshopping = (): [LiveShopping | undefined, RequestStateQuery] => {
  const { httpJson } = useHttp();

  const get = useCallback(
    async () =>
      httpJson<ApiResponse<ElasticSearchResponse<LiveShopping>>>(
        '/api/live-shopping/featured',
        buildGetRequest(),
      ),
    [],
  );

  const { data, isPending, isSuccess, isError } = useQuery<
    ApiResponse<ElasticSearchResponse<LiveShopping>>
  >({
    queryKey: [FEATURED_LIVESHOPPING],
    queryFn: get,

    retry: false,
    refetchOnWindowFocus: false,
    gcTime: Number.POSITIVE_INFINITY,
    staleTime: Number.POSITIVE_INFINITY,
  });

  return [
    data?.response?.documentList?.documents?.[0],
    { isLoading: isPending, isSuccess, isError },
  ];
};

export default useFeaturedLiveshopping;
